import React, { Component } from "react";
import { Modal, Row, Col, Input, Button, message, Icon, Spin } from "antd";
import { Translate } from "react-translated";
import axios from "axios";
import F from "../../../Functions";
import { REVIEW } from "../../../utils/Constants";
import { RESET_BFILE_API_URL } from "../../../utils/Api_enums";
import moment from "moment";

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;

class UserEditModal extends Component {
  state = {
    phone: this.props.bfile.phone,
    loading: false,
  };

  componentDidUpdate = (prevProps) => {
    if (prevProps.showModal !== this.props.showModal) {
      this.setState({ phone: this.props.bfile.phone });
    }
  };


  // updatePhoneNumber = () => {
  //   const errors = [];
  //   this.setState({ saveBtnDisabled: true });
  //   if (this.state.phone === null || this.state.phone === "") {
  //     errors.push("Phone is Mandatory.");
  //   }

  //   // validate regix
  //   if (!F.validatePhoneRegix(this.state.phone)) {
  //     errors.push("Phone is Invalid");
  //   }

  //   // reset notification

  //   message.destroy();
  //   if (errors && errors.length > 0) {
  //     message.error(errors[0]);
  //   }

  //   if (errors.length === 0) {
  //     const phoneNumberFormatterRemoved = F.removeFormatterFromPhoneNumber(
  //       this.state.phone
  //     );

  //     this.setState({ loading: true });

  //     // check customer exist
  //     axios
  //       .post("/api/check_customer_exist", {
  //         phone: phoneNumberFormatterRemoved,
  //         skip_child: true, // only parent will consider
  //         agency_id: this.props.bfile.agency_id,
  //       })
  //       .then((res) => {
  //         this.setState({ loading: false });
  //         // found duplicate
  //         if (res.data.exist && this.props.bfile.id !== res.data.bfile_id) {
  //           // reset notification
  //           message.destroy();
  //           message.error(
  //             "Customer already exists with the same Phone Number."
  //           );
  //         } else {
  //           // unique customer
  //           axios
  //             .put(`/api/b_file/${this.props.bfile.id}`, {
  //               phone: phoneNumberFormatterRemoved,
  //               bad_phone_number_status: false,
  //             })
  //             .then((response) => {
  //               this.props.init();
  //               this.props.hideModal();
  //               // window.location.reload();
  //             })
  //             .catch((error) => {
  //               F.log(error);
  //             });

  //           const bfile = this.props.bfile;


  //           if (!bfile) return;

  //           const user_ids_SA = [bfile.user_id];

  //           const target_user_id = bfile.reviewer_id
  //             ? bfile.reviewer_id
  //             : bfile.onboarder_id;

  //           const user_ids = [target_user_id];

  //           const useSA =
  //             (bfile.reviewer_id === 1 || bfile.onboarder_id === 1);

  //           let data = {
  //             notification_message: `The phone number for ###${this.props.bfile.first_name}   ${this.props.bfile.last_name}### has been updated for ${this.props.bfile.agency.name}`,
  //             severity: "low",
  //             dispatch_time: Math.floor(Date.now() / 1000),
  //             user_ids: useSA ? user_ids_SA : user_ids,
  //             bfile_id: this.props.bfile.id,
  //           };
  //           F.log("res.data = > ", data);
  //           axios.post("/api/create_notification", data).then((res) => {
  //             F.log("res.data = > ", res);
  //             message.success(F.translate(`Notification Sent Successfully`));
  //           });
  //           axios.post("/api/bfile_notes", {
  //             bfile_id: this.props.bfile.id,
  //             note: `The Phone Number of ${this.props.bfile.first_name +
  //               " " +
  //               this.props.bfile.last_name} has been Updated.`,
  //             user_id: this.props.bfile.user.id,
  //             action: "Phone Number Update",
  //           });
  //         }
  //       })
  //       .catch((error) => {
  //         this.setState({ loading: false });
  //       })
  //       .finally(() => {
  //         setTimeout(() => {
  //           window.location.reload();
  //           this.setState({ saveBtnDisabled: false });
  //         }, 2000);

  //       });
  //   }
  // };




  updatePhoneNumber = () => {
    const bfile = this.props.bfile;
    const errors = [];
    this.setState({ saveBtnDisabled: true });
    if (this.state.phone === null || this.state.phone === "") {
      errors.push("Phone is Mandatory.");
    }

    // validate regix
    if (!F.validatePhoneRegix(this.state.phone)) {
      errors.push("Phone is Invalid");
    }

    // reset notification

    message.destroy();
    if (errors && errors.length > 0) {
      message.error(errors[0]);
    }

    if (errors.length === 0) {
      const phoneNumberFormatterRemoved = F.removeFormatterFromPhoneNumber(
        this.state.phone
      );

      this.setState({ loading: true });

      // check customer exist
      axios
        .post("/api/check_customer_exist", {
          phone: phoneNumberFormatterRemoved,
          skip_child: true, // only parent will consider
          agency_id: this.props.bfile.agency_id,
        })
        .then((res) => {
          this.setState({ loading: false });
          // found duplicate
          if (res.data.exist && this.props.bfile.id !== res.data.bfile_id) {
            // reset notification
            message.destroy();
            message.error(
              "Customer already exists with the same Phone Number."
            );
          } else {
            // unique customer


            const isExpired =
              (bfile.type_of_call === REVIEW &&
                moment(bfile.expiration_date).isBefore(moment(), "day")) ||
              (bfile.bfile_sub &&
                bfile.bfile_sub.length > 0 &&
                bfile.bfile_sub[0].fs_expiration_date &&
                moment(bfile.bfile_sub[0].fs_expiration_date).isBefore(moment(), "day"));


            axios
              .put(`/api/b_file/${this.props.bfile.id}`, {
                phone: phoneNumberFormatterRemoved,
                bad_phone_number_status: false,
              })
              .then((response) => {

                if (isExpired) {
                  axios
                    .put(RESET_BFILE_API_URL(this.props.bfile.id), {
                      phone_number: phoneNumberFormatterRemoved,
                    })
                    .then((res) => {
                      console.log("RESET BFILE SUCCESS 👉", res.data);
                    })
                    .catch((err) => {
                      console.error(
                        "RESET BFILE ERROR 👉",
                        err.response.data || err.message
                      );
                    });
                }


                this.props.init();
                this.props.hideModal();
                // window.location.reload();
              })
              .catch((error) => {
                F.log(error);
              });




            if (!bfile) return;

            const user_ids_SA = [bfile.user_id];

            const target_user_id = bfile.reviewer_id
              ? bfile.reviewer_id
              : bfile.onboarder_id;

            const user_ids = [target_user_id];

            const useSA =
              (bfile.reviewer_id === 1 || bfile.onboarder_id === 1);

            let data = {
              notification_message: `The phone number for ###${this.props.bfile.first_name}   ${this.props.bfile.last_name}### has been updated for ${this.props.bfile.agency.name}`,
              severity: "low",
              dispatch_time: Math.floor(Date.now() / 1000),
              user_ids: useSA ? user_ids_SA : user_ids,
              bfile_id: this.props.bfile.id,
            };
            F.log("res.data = > ", data);
            axios.post("/api/create_notification", data).then((res) => {
              F.log("res.data = > ", res);
              message.success(F.translate(`Notification Sent Successfully`));
            });
            axios.post("/api/bfile_notes", {
              bfile_id: this.props.bfile.id,
              note: `The Phone Number of ${this.props.bfile.first_name +
                " " +
                this.props.bfile.last_name} has been Updated.`,
              user_id: this.props.bfile.user.id,
              action: "Phone Number Update",
            });
          }
        })
        .catch((error) => {
          this.setState({ loading: false });
        })
        .finally(() => {
          setTimeout(() => {
            window.location.reload();
            this.setState({ saveBtnDisabled: false });
          }, 2000);

        });
    }
  };



  render() {
    let title = "Edit Phone Number";
    const { saveBtnDisabled } = this.state || {};
    return (
      <Modal
        title={<Translate text={title} />}
        visible={this.props.showModal}
        footer={
          <div>
            <Button onClick={this.updatePhoneNumber}
              type="primary"
              disabled={saveBtnDisabled}
            >
              <Translate text={`Save`}
              />
            </Button>
          </div>
        }
        onCancel={this.props.hideModal}
      >
        <Spin indicator={antIcon} spinning={this.state.loading}>
          <Row gutter={16}>
            <Col md={12} span={24}>
              <label>
                <Translate text={`First Name`} />:
              </label>
              <Input
                className="inputfield"
                value={this.props.bfile.first_name}
                disabled
                maxLength={50}
              />
            </Col>
            <Col md={12} span={24}>
              <label>
                <Translate text={`Last Name`} />:
              </label>
              <Input
                className="inputfield"
                value={this.props.bfile.last_name}
                disabled
                maxLength={50}
              />
            </Col>
          </Row>
          <Row gutter={16}>
            <Col md={12} span={24}>
              <label>
                <Translate text={`Phone`} />:
              </label>
              <Input
                value={F.phone_format(this.state.phone)}
                onChange={(e) => {
                  if (e.target.value.trim().length <= 14) {
                    const number = F.phone_format(e.target.value);
                    this.setState({ phone: number });
                  }
                }}
              />
            </Col>
            <Col md={12} span={24}>
              <label>
                <Translate text={`Email`} />:
              </label>
              <Input value={this.props.bfile.email} disabled />
            </Col>
          </Row>
        </Spin>
      </Modal>
    );
  }
}

export default UserEditModal;



// WEBPACK FOOTER //
// ./src/scenes/LandingPage/parts/user-edit-modal.js